import './Input.scss';

import React, { FC, ReactNode, KeyboardEvent, ChangeEvent, FocusEvent } from 'react';
import TypedMessage from "../../atoms/TypedMessage/TypedMessage";

interface IInput {
    className?: string;
    classError?: string;
    name: string;
    // Добавляем 'number' в типизацию
    type?: "text" | "password" | "email" | "date" | "number";
    placeholder: string;
    ErrorMessage?: ReactNode;
    message?: any;
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
    value?: string | number; // Разрешаем number, так как родитель может хранить число
    innerRef?: any;
}

const Input: FC<IInput> = ({
                                               innerRef,
                                               name,
                                               className = "",
                                               classError,
                                               type = "text",
                                               placeholder,
                                               onBlur,
                                               onKeyDown = () => { },
                                               onChange,
                                               value,
                                               message = "",
                                               ErrorMessage
                                           }) => {

    // Проверяем, является ли тип числовым
    const isNumberType = type === 'number';

    // Форматируем значение для отображения (добавляем запятые)
    // Используем Intl.NumberFormat или регулярку.
    // Если value нет, возвращаем пустую строку.
    const getDisplayValue = () => {
        if (value === undefined || value === null || value === '') return '';
        if (isNumberType) {
            // Удаляем всё кроме цифр перед форматированием на случай "грязных" данных
            const cleanVal = String(value).replace(/,/g, '');
            if (!cleanVal) return '';
            return cleanVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return value;
    };

    // Перехватываем событие ввода
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (!onChange) return;

        if (isNumberType) {
            // Получаем то, что ввел пользователь (например "1,000,05")
            const inputValue = e.target.value;

            // Удаляем запятые, чтобы получить чистое число (например "100005")
            // Также блокируем ввод не-цифр (букв и т.д.)
            const rawValue = inputValue.replace(/,/g, '').replace(/\D/g, '');

            // Модифицируем value в событии, чтобы родитель получил чистое число
            e.target.value = rawValue;

            // Отправляем событие родителю
            onChange(e);
        } else {
            // Для всех остальных типов работаем как обычно
            onChange(e);
        }
    };

    return (
        <>
            <div className={`input-gradient ${className}`}>
                <label>
                    <input
                        onKeyDown={onKeyDown}
                        autoComplete={'off'}
                        ref={innerRef}
                        placeholder={' '}
                        // Если type="number", меняем на "text", чтобы разрешить запятые
                        type={isNumberType ? "text" : type}
                        onChange={handleChange}
                        onBlur={onBlur}
                        name={name}
                        // Используем отформатированное значение
                        value={getDisplayValue()}
                        // Для мобилок: чтобы открывалась цифровая клавиатура даже при type="text"
                        inputMode={isNumberType ? "numeric" : undefined}
                    />
                    <span className="input-gradient__label">{placeholder}</span>
                    <div className={`input-gradient__message ${message !== "" ? "active" : ""}`}>
                        {message !== "" && <TypedMessage cursor={false} loop={false} className={'input-gradient__message-text'} strings={[message]} />}
                    </div>
                </label>
            </div>
            {ErrorMessage && <p style={{ color: "#DB3522", fontSize: "12px" }}>{ErrorMessage}</p>}
        </>
    );
};

export default Input;